import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { map, tap } from "rxjs/operators";
import { PagesEventService, Url, Utilities } from "src/app/common";
import { User, UserAuth } from "src/app/common/user-auth";
import { GridService } from "../../pages/default/custom-grid/services/grid.service";
import { notificationColumns } from "../models/notification-columns.model";
import { ConfirmDialogService } from "../services/confirm-dialog.component";
import { LayoutService } from "../services/layout.service";
import { WindowService } from "@progress/kendo-angular-dialog";
import { TranslateService } from "@ngx-translate/core";
import { DebutyComponent } from "./deputy.component";
import { DebutyListComponent } from "./deputy-list.component";
import { EmailNotificationComponent } from "./email-notification.component";

@Component({
  selector: "app-user-notifications",
  templateUrl: "../views/notifications.component.html",
  styleUrls: ["../styles/style.css","../styles/notifications.css"],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationsComponent implements OnInit {
  notifications: Notification[] = [];
  employees: any[] = [];
  selectedNotification: Notification = null;
  dialogs = {
    confirmDelete: false,
    forward: false,
    done: false,
    settingsNotifications: false,
  };
  forwardDialogModel = { emp: null };
  notificationColumns = notificationColumns;
  sendEmailNotification = null;
  userAuth: User = UserAuth.get();
  dataObservaleProvider: Function;
  selectAllNotifications = null;
  documentsVersion = [];
  settingsNotificationList = [];
  onSaving = false;
  showArchive=false;

  url = Url;
  @Output() public formClosed: EventEmitter<any> = new EventEmitter();

  constructor(
    private pagesEventService: PagesEventService,
    public layoutService: LayoutService,
    private router: Router,
    private gridService: GridService,
    private windowService: WindowService,
    private translateService: TranslateService,
    private viewContainerRef: ViewContainerRef,
    public confirmDialogService: ConfirmDialogService
  ) {}

  ngOnInit() {
    this.getEmployee();
    this.dataObservaleProvider = this.dataNotificationsProvider.bind(this);
  }

  dataNotificationsProvider(state, filter) {
    return this.layoutService.searchNotifications(state, filter,this.showArchive).pipe(
      map((response) => {
        Utilities.parseToDateObject(
          response.data,
          this.notificationColumns.filter((a) => a.filter == "date")
        );
        return response;
      }),
      tap(() => this.gridService.updateRows(this.gridService.data))
    );
  }

  isCheckedAnyNotification(): boolean {
    return this.gridService.data.filter((i) => i.checked).length > 0;
  }

  onSelectAllNotificationsChanged() {
    this.gridService.data.forEach(
      (item) => (item.checked = this.selectAllNotifications ? true : false)
    );
    this.gridService.updateRows(this.gridService.data);
    this.onNotificationCheckedChanged();
  }

  setOnSaving(value) {
    this.onSaving = value;
    this.pagesEventService.onSaving(value);
  }

  initSettingsNotificationList() {
    this.settingsNotificationList = [

      {
        type: "inventoryEndDateExpired",
        module: "Planung",
        designationNotification: "Plandatum Inventarisierung abgelaufen",
        triggerNotification:
          "Das Inventory-Plandatum ist abgelaufen",
        recipientNotification:
          "Projektleitung Projekt / Gebietsmanagement Engineering / Design Engineering",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectAcquisitionReset",
        module: "Akquisition",
        designationNotification: "Zurücksetzung Losfreigabe Akquisition",
        triggerNotification: 'Die Losfreigabe Akquisition wurde für eine Lokation zurückgesetzt',
        recipientNotification:
          "Gebietsmanagement Engineering Projekt / Ansprechperson Multinet Spezifikation / Bauleitung Projekt / Zentrale Inventarisierungsstelle Projekt Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectAcquisitionDone",
        module: "Verträge / Site Visit",
        designationNotification: "Freigabe Akquisition",
        triggerNotification:
          "Die Akquisition eines oderer mehrer Lokationen wurde freigegeben",
        recipientNotification:
          "Gebietsmanagement Engineering, Ansprechperson Design",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,

      },
      {
        type: "locationImportCompleted",
        module: "Design",
        designationNotification: "Lokationenimport abgeschlossen",
        triggerNotification:
          "Funktion 'Meldung an Akquisition' im Modul Design wurde bestätigt",
        recipientNotification: "Gebietsmanagement Akquisition / Projektleitung Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectExecutionDesignDone",
        module: "Ausführungsdesign",
        designationNotification: "Freigabe Ausführungsdesign",
        triggerNotification:
          "Das Ausführungsdesign eines Loses/Feeders wird freigegeben",
        recipientNotification: "Gebietsmanagement Engineering Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "deepomaticMessages",
        module: "Dokumentation / QC",
        designationNotification: "Neue Nachrichten-Dokumentation",
        triggerNotification: "Neue Nachricht zur X-Dokumentation",
        recipientNotification: "Ausgewählter Experte/ Techniker",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "deepomaticStatusChanged",
        module: "Dokumentation / QC",
        designationNotification: "Dokumentationsstatus geändert",
        triggerNotification: "Neuer Status zur X-Dokumentation",
        recipientNotification: "Ausgewählter Experte/ Techniker",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "notifyConstructionScheduleMonitoring",
        module: "Drop",
        designationNotification: "Ablauf Plandatum Bau in 15 AT",
        triggerNotification: "Ablauf Plandatum Bau in 15 AT",
        recipientNotification: "Bauleiter / Gebietsmanagement Bau",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectDropDone",
        module: "Drop",
        designationNotification: "Freigabe Realisation Drop",
        triggerNotification: "Die Realisation eines Loses wird freigegeben",
        recipientNotification: "Zentrale Inventarisierungsstelle Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "locationDropNetworkConstructionNotPossible",
        module: "Drop",
        designationNotification: "Erschliessung Lokation nicht möglich",
        triggerNotification:
          'Bei einer Location wurde "Netzbau nicht möglich" gemeldet',
        recipientNotification:
          "Gebietsmanagement Akquisition / Bauleitung Realisation / Gebietsmanagement Realisation / QC-Supervisor Hauseinführung",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "locationDropInhouseNotPossible",
        module: "Drop",
        designationNotification: "Erschliessung Lokation nicht möglich",
        triggerNotification:
          'Bei einer Location wurde "Inhouse nicht möglich" gemeldet',
        recipientNotification:
          "Bauleitung Realisation / Gebietsmanagement Realisation / QC-Supervisor BEP",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectDropLocationRequestAppointment",
        module: "Drop",
        designationNotification: "Anfrage neue Terminierung",
        triggerNotification:
          "User beantragt eine Neu-terminierung einer Lokation",
        recipientNotification: "Ersteller Termin",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "projectDropSleeveRequestAppointment",
        module: "Drop",
        designationNotification: "Anfrage neue Terminierung",
        triggerNotification: "User beantragt eine Neu-terminierung einer Muffe",
        recipientNotification: "Ersteller Termin",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },

      {
        type: "projectDropConstructionStart",
        module: "Drop",
        designationNotification: "AVOR abgeschlossen",
        triggerNotification: "Die AVOR eines Loses wurde bestätigt",
        recipientNotification: "Projektleitung Projekt / Gebietsmanagement Realisation",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectDropRelease",
        module: "Drop",
        designationNotification: "Freigabe Drop",
        triggerNotification: "Die Drop eines Loses wurde freigegeben",
        recipientNotification: "Gebietsmanagement Engineering Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectOtoDone",
        module: "OTO",
        designationNotification: "Freigabe Realisation OTO",
        triggerNotification: "Die Realisation eines Loses wird freigegeben",
        recipientNotification: "Zentrale Inventarisierungsstelle Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "locationOtoNotPossible",
        module: "OTO",
        designationNotification: "Erschliessung Lokation nicht möglich",
        triggerNotification:
          'Bei einer Location wurde "OTO nicht möglich" gemeldet',
        recipientNotification:
          "Gebietsmanagement Akquisition / Bauleitung Realisation / Gebietsmanagement Realisation / QC-Supervisor OTO",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectOtoLocationRequestAppointment",
        module: "OTO",
        designationNotification: "Anfrage neue Terminierung",
        triggerNotification:
          "User beantragt eine Neu-terminierung einer Lokation",
        recipientNotification: "Ersteller Termin",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "projectOtoRelease",
        module: "OTO",
        designationNotification: "Freigabe OTO",
        triggerNotification: "Die OTO eines Loses wurde freigegeben",
        recipientNotification: "Gebietsmanagement Engineering Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "locationContractUpdatedBottlenecks",
        module: "Engpässe",
        designationNotification: "Engpässe nicht Bewilligt",
        triggerNotification:
          "Der Engpasss wurde seitens Aquisition nicht bewilligt",
        recipientNotification: "Designer/Planer",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "InventarisierungChatMessageCreated",
        module: "Inventarisierung",
        designationNotification: "Neue Nachricht",
        triggerNotification: "Es wurde eine neue Nachricht erfasst",
        recipientNotification: "Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "auditedRevisionDocumentChanged",
        module: "Inventarisierung",
        designationNotification: "Änderung an geprüftem Revisionsdokument",
        triggerNotification: "Eine Änderung wird an einem Revisionsdokument (im Modul Drop, OTO oder Inventar) gespeichert, das bereits im Modul Inventar geprüft wurde.",
        recipientNotification: "Dokumentprüfer (User taht confirmed Document)",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "deviationCorrectionDone",
        module: "Abweichung",
        designationNotification: "Korrektur Abweichung",
        triggerNotification:
          "Eine beauftragte Abweichung wurde als erledigt markiert",
        recipientNotification: "Erfasser Korrekturauftrag",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectExecutionDesignRelease",
        module: "Ausführungsdesign",
        designationNotification: "Freigabe Ausführungsdesign",
        triggerNotification: "Das Ausführungsdesign eines Loses wurde freigegeben",
        recipientNotification: "Gebietsmanagement Engineering Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "executionDesignDeviationCreated",
        module: "Ausführungsdesign",
        designationNotification: "Erfassung Abweichung",
        triggerNotification: "Es wurde eine neue Abweichung erfasst",
        recipientNotification: "Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "deviationCreated",
        module: "Inventarisierung",
        designationNotification: "Erfassung Abweichung",
        triggerNotification: "Es wurde eine neue Abweichung erfasst",
        recipientNotification: "Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "projectInventoryChecked",
        module: "Inventarisierung",
        designationNotification: "Prüfung Inventarisierung",
        triggerNotification:
          "Die Inventarisierung eines Loses/Feeders wurde erfolgreich geprüft",
        recipientNotification: "Gebietsmanagement Engineering Projekt / Design Engineering",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "notifyInventoryDeliveryDateExpired",
        module: "Inventarisierung",
        designationNotification: "Liefertermin Inventarisierung abgelaufen",
        triggerNotification:
          "Der angegebene Liefertermin Inventarisierung ist abgelaufen",
        recipientNotification:
          "Ansprechperson Design / User Start Inventarisierung",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "deviationDateExpired",
        module: "Inventarisierung",
        designationNotification:
          "Korrkturtermin Abweichung wurde überschritten",
        triggerNotification:
          "Der Korrekturtermin einer Abweichung wurde überschritten",
        recipientNotification: "Erfasser Korrekturauftrag / Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "locationContractUpdatedShaft",
        module: "Schächte",
        designationNotification: "Schächte nicht Bewilligt",
        triggerNotification:
          "Der Schacht wurde seitens Aquisition nicht bewilligt",
        recipientNotification: "Designer/Planer",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "contractRetryScheduledStatus",
        module: "Verträge",
        designationNotification:
          "Der Vertrag konnte noch nicht versendet werden",
        triggerNotification:
          'Erhaltener digital Status "Contract Retry Scheduled"',
        recipientNotification:
          "Der Benutzer der den Vertrag digital gesendet / unterzeichnet hat",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "contractCompletedStatus",
        module: "Verträge",
        designationNotification: "Der Vertrag wurde unterzeichnet und abgelegt",
        triggerNotification: 'Erhaltener digital Status "Completed"',
        recipientNotification:
          "Der Benutzer der den Vertrag digital gesendet / unterzeichnet hat",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "reminder1SentDigitally",
        module: "Verträge",
        designationNotification: "Erinnerung 1 digital versendet",
        triggerNotification: 'Erhaltener Reminder-Status "first"',
        recipientNotification:
          "Der Benutzer der den Vertrag digital gesendet / unterzeichnet hat",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "reminder2SentDigitally",
        module: "Verträge",
        designationNotification: "Erinnerung 2 digital versendet",
        triggerNotification: 'Erhaltener Reminder-Status "second"',
        recipientNotification:
          "Der Benutzer der den Vertrag digital gesendet / unterzeichnet hat",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "contractDue",
        module: "Verträge",
        designationNotification: "Vertrag fällig",
        triggerNotification: 'Attribut "Vertrag fällig"',
        recipientNotification:
          "Sachbearbeiter in der Lokation in Verträge / Vertrag",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "siteVisitRedesignCreated",
        module: "Site Visit",
        designationNotification: "Redesign erfasst",
        triggerNotification: "Es wurde ein neues Redesign erfasst",
        recipientNotification: "Gebietsmanagement Akquisition Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "resendSAR",
        module: "Site Visit",
        designationNotification: "SAR erneut senden",
        triggerNotification: "Es wurden Änderungen vorgenommen, nachdem der SAR an Swisscom übermittelt wurde.",
        recipientNotification: "Gebietsmanagement Akquisition Projekt",
        active: true,
        notificationEmail: true,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "locationUsageUnitsUpdated",
        module: "Site Visit",
        designationNotification: "Nachträgliche Änderung Nutzungseinheiten",
        triggerNotification: "Die Anzahl Nutzungseinheiten aus Aufnahme wurde nach der Bestätigung im Ausführungsdesign erneut verändert oder es hat eine neue Veränderung nach Freigabe Ausführungsdesign stattgefunden",
        recipientNotification:'Gebietsmanagement Engineering / Gebietsmanagement Akquisition / Ansprechperson Design / "User Bestätigung Änderung Nutzungseinheiten"',
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "siteVisitRedesignRejected",
        module: "Site Visit",
        designationNotification: "Redesign abgelehnt",
        triggerNotification: "Ein erfasstes Redesign wurde abgelehnt",
        recipientNotification: "Erfasser Redesign",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectLocationStatusChanged",
        module: "Akquistion",
        designationNotification:
          "Stauswechsel Akquisition nach Freigabe Ausführungsdesign oder Spezifikation",
        triggerNotification:
          "Abschluss Akquisition nach erfolgter Los-/Feederfreigabe Ausführungsdesign oder Spezifikation",
        recipientNotification:
          "Gebietsmanagement Engineering Projekt / Ansprechperson Multinet Spezifikation / Design Engineering",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "SpezifikationChatMessageCreated",
        module: "Spezifikation",
        designationNotification: "Neue Nachricht",
        triggerNotification: "Es wurde eine enue Nachricht erfasst",
        recipientNotification: "Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "projectSpecificationChecked",
        module: "Spezifikation",
        designationNotification: "Prüfung Spezifikation",
        triggerNotification:
          "Die Spezifikation eines Loses/Feeders wurde erfolgreich geprüft",
        recipientNotification: "Gebietsmanagement Engineering Projekt / Design Engineering",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectSpecificationConfirmed",
        module: "Spezifikation",
        designationNotification: "Freigabe Spezifikation",
        triggerNotification:
          "Die Spezifikation eines Loses/Feeders wurde freigegeben",
        recipientNotification:
          "Gebietsmanagement Engineering Projekt / Gebietsmanagement Realisation Projekt / Zentrale Inventarisierungsstelle / Design Engineering",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectSpecificationDone",
        module: "Spezifikation",
        designationNotification: "Abschluss Spezifikation",
        triggerNotification:
          "Die Spezifikation eines Loses/Feeders wurde abgeschlossen",
        recipientNotification: "Ansprechperson Multinet Spezifikation / Design Engineering",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
        mandatoryEmail: true,
      },
      {
        type: "projectSpecificationRelease",
        module: "Spezifikation",
        designationNotification: "Freigabe Spezifikation",
        triggerNotification: "Das Spezifikation eines Loses wurde freigegeben",
        recipientNotification: "Design Engineering",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "notifySpecificationDeliveryDateExpired",
        module: "Spezifikation",
        designationNotification: "Liefertermin Spezifikation abgelaufen",
        triggerNotification:
          "Der angegebene Liefertermin Spezifikation ist abgelaufen",
        recipientNotification:
          "Ansprechperson Design / User Start Spezifikation / Design Engineering",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectSpecificationDocumentEdited",
        module: "Spezifikation",
        designationNotification:
          "Dokument nach Freigabe Spezifikation editiert",
        triggerNotification:
          "Ein bestehendes Dokument wurde nach Freigabe der Spezifikation editiert",
        recipientNotification:
          "Gebietsmanagement Realisation / Bauleiter Realisation / Zentrale Inventarisierungsstelle",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
        mandatoryEmail: true,
      },
      {
        type: "projectSpecificationNewDocument",
        module: "Spezifikation",
        designationNotification:
          "Dokument nach Freigabe Spezifikation hochgeladen",
        triggerNotification:
          "Ein neues Dokument wurde nach Freigabe der Spezifikation hochgeladen",
        recipientNotification:
          "Gebietsmanagement Realisation / Bauleiter Realisation / Zentrale Inventarisierungsstelle",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
        mandatoryEmail: true,
      },
      {
        type: "projectSpecificationDocumentDeleted",
        module: "Spezifikation",
        designationNotification:
          "Dokument nach Freigabe Spezifikation gelöscht",
        triggerNotification:
          "Ein bestehendes Dokument wurde nach Freigabe der Spezifikation gelöscht",
        recipientNotification:
          "Gebietsmanagement Realisation / Bauleiter Realisation / Zentrale Inventarisierungsstelle",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
        mandatoryEmail: true,
      },
      {
        type: "projectSpecificationDocumentNewVersion",
        module: "Spezifikation",
        designationNotification:
          "Neue Version eines Dokuments nach Freigabe Spezifikation",
        triggerNotification:
          "Von einem bestehenden Dokument wurde nach Freigabe der Spezifikation eine neue Version hochgeladen",
        recipientNotification:
          "Gebietsmanagement Realisation / Bauleiter Realisation / Zentrale Inventarisierungsstelle",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
        mandatoryEmail: true,
      },
      {
        type: "ticketCreated",
        module: "Ticket",
        designationNotification: "Erfassung Ticket",
        triggerNotification: "Ein Ticket wurde erfasst",
        recipientNotification: "markierte Support-Gruppe",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "ticketReplyCreated",
        module: "Ticket",
        designationNotification: "Kommentar Ticket",
        triggerNotification: "Auf einem Ticket wurde ein Kommentar erfasst",
        recipientNotification: "Erfasser Ticket",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "noTimeToCompensate",
        module: "Time Management",
        designationNotification: "Reststunden Kompensation aufgebraucht",
        triggerNotification:
          "Das Stundensaldo hat -80 Stunden erreicht und Restguthaben Urlaub auf 0",
        recipientNotification: "HR",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "timeManagementMessageCreated",
        module: "Time Management",
        designationNotification: "Neue Nachricht",
        triggerNotification: "Es wurde eine neue Nachricht erfasst",
        recipientNotification: "Betroffener Nutzer",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: true,
      },
      {
        type: "timeManagementWeekConfirmed",
        module: "Time Management",
        designationNotification: "Kalenderwoche bestätigt",
        triggerNotification: "Der Wochenrapport wurde bestätigt",
        recipientNotification: "Betroffener Nutzer / SuperVisor Zeitmanagement",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: false,
      },
      {
        type: "timeManagementWeekRejected",
        module: "Time Management",
        designationNotification: "Kalenderwoche abgelehnt",
        triggerNotification: "Der Wochenrapport wurde abgelehnt",
        recipientNotification: "Betroffener Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: false,
      },
      {
        type: "vacationDeleted",
        module: "Time Management",
        designationNotification: "Urlaub gelöscht",
        triggerNotification: "Ein erfasster Urlaub wurde gelöscht",
        recipientNotification: "SuperVisor Zeitmanagement",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "vacationResponseCreated",
        module: "Time Management",
        designationNotification: "Urlaubsgesuch bewilligt / abgelehnt",
        triggerNotification: "Ein Urlaubsgesuch wurde bewilligt / abgelehnt",
        recipientNotification: "Erfasser Urlaubsgesuch",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: false,
      },
      {
        type: "vacationCreatedNotification",
        module: "Time Management",
        designationNotification: "Urlaub beantragt Modul",
        triggerNotification: "Ein Urlaubsantrag wurde eingereicht",
        recipientNotification: "SuperVisor Zeitmanagement",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: false,
      },
      {
        type: "projectInspectionCreated",
        module: "Abnahmen",
        designationNotification: "Erfassung Abnahme",
        triggerNotification: "Es wurde eine neue Abnahme erfasst",
        recipientNotification: "Projektleitung Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "projectInspectionDefectCreated",
        module: "Abnahmen",
        designationNotification: "Erfassung Mangel",
        triggerNotification: "Es wurde eine enuer Mangel erfasst",
        recipientNotification: "Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "inspectionDefectCorrectionDone",
        module: "Abnahmen",
        designationNotification: "Korrektur Mangel",
        triggerNotification:
          "Eine beauftrage Mangelkorrektur wurde als erledigt markiert",
        recipientNotification: "Projektleitung Projekt",
        active: true,
        notificationEmail: false,
        notificationPush: false,
        mandatoryNotification: false,
      },
      {
        type: "inspectionDefectDateExpired",
        module: "Abnahmen",
        designationNotification: "Korrekturtermin Mangel wurde überschritten",
        triggerNotification:
          "Der Korrekturtermin eines Mangels wurde überschritten",
        recipientNotification: "Projektleitung Projekt / Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "reminderDate",
        module: "Diverse",
        designationNotification: "Fällige Erinnerung",
        triggerNotification: "Der gesetzte Erinnerungstermin ist Heute",
        recipientNotification: "Erfasser Erinnerung",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "documentCreated",
        module: "Vorlagen & Richtlinien",
        designationNotification: "Neues Dokument",
        triggerNotification: "Es wurde ein neues Dokument abgelegt",
        recipientNotification: "Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "individualAppointmentParticipantAdded",
        module: "Kalender",
        designationNotification: "Termineinladung",
        triggerNotification: "Ein User wird zu einem Termin eigeladen",
        recipientNotification: "Teilnehmer Termin",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "individualAppointmentDeleted",
        module: "Kalender",
        designationNotification: "Terminlöschung Organisator",
        triggerNotification: "Ein Termin wird vom Organisator gelöscht",
        recipientNotification: "Teilnehmer Termin",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "individualAppointmentParticipantDeleted",
        module: "Kalender",
        designationNotification: "Terminlöschung Teilnehmer",
        triggerNotification: "Ein Termin wird vom Teilnehmer gelöscht",
        recipientNotification: "Organisator Termin",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "AusführungsdesignChatMessageCreated",
        module: "Ausführungsdesign",
        designationNotification: "Neue Nachricht",
        triggerNotification: "Es wurde eine neue Nachricht erfasst",
        recipientNotification: "Markierter Nutzer",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type:'notificationValidityVisa',
        module:'Personal',
        designationNotification:'Ablauf des Visums',
        triggerNotification:'Das Visum von (Name des Mitarbeiters) wird am (Datum) ablaufen',
        recipientNotification:'HR',
        active:true,
        notificationEmail:true,
        notificationPush:true,
        mandatoryNotification:false
      },
      {
        type: "endTimeLine",
        module: "Time Management",
        designationNotification: "Arbeitszeitlimit erreicht",
        triggerNotification: "Automatische Zeiterfassung wird nach 12 Stunden gestoppt",
        recipientNotification: "Employee",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },
      {
        type: "processWordDocument",
        module: "Vorlagenmanager",
        designationNotification: "NotificationGenerierte Dokumente sind fertig",
        triggerNotification: "NotificationIhre generierte Aufgabe wurde abgeschlossen",
        recipientNotification: "NotificationBenutzer, der diese Generierung gestartet hat, wird sie erhalten",
        active: true,
        notificationEmail: true,
        notificationPush: true,
        mandatoryNotification: true,
      },

      
    ].sort((a, b) => a.module.localeCompare(b.module));
  }

  openDeputyModal() {
    this.translateService
      .get("Neue Stellvertretung")
      .subscribe((transleted) => {
        const windowRef = this.windowService.open({
          title: transleted,
          content: DebutyComponent,
          width: 1200,
          appendTo: this.viewContainerRef,
          top: 200,
        });

        windowRef.result.subscribe((result) => {});

        let notificationsComponent: DebutyComponent = windowRef.content
          .instance as DebutyComponent;
        notificationsComponent.formClosed.subscribe((formData) => {
          windowRef.close();
        });
      });
  }

  openEmailNotificationModal() {
    const windowRef = this.windowService.open({
      title: "Email Notificationen",
      content: EmailNotificationComponent,
      width: 1200,
      appendTo: this.viewContainerRef,
      top: 200,
    });

    windowRef.result.subscribe((result) => {});

    let emailNotificationComponent: EmailNotificationComponent = windowRef
      .content.instance as EmailNotificationComponent;
    emailNotificationComponent.formClosed.subscribe((formData) => {
      windowRef.close();
    });
  }

  openDeputyHistoryModal() {
    this.translateService.get("Stellvertretung").subscribe((transleted) => {
      const windowRef = this.windowService.open({
        title: transleted,
        content: DebutyListComponent,
        width: 1400,
        appendTo: this.viewContainerRef,
        top: 200,
      });

      windowRef.result.subscribe((result) => {});

      let notificationsComponent: DebutyListComponent = windowRef.content
        .instance as DebutyListComponent;
      notificationsComponent.formClosed.subscribe((formData) => {
        windowRef.close();
      });
    });
  }

  saveSettingsNotification() {
    this.setOnSaving(true);
    this.layoutService
      .saveSettingsNotification({ settings: this.settingsNotificationList })
      .subscribe((response) => {
        if (response.Status == 200) {
          this.setOnSaving(false);
          this.dialogs.settingsNotifications = false;
        }
      });
  }

  getSettingsNotification() {
    this.layoutService.getSettingsNotification().subscribe((response) => {
      if (response.Status == 200 && response.Notifications.length) {
        let notifications = response.Notifications;
        this.settingsNotificationList = this.settingsNotificationList.map(
          (objA) => {
            const objB = notifications.find((obj) => obj.type === objA.type);
            if (objB) return { ...objA, ...objB };

            return objA;
          }
        );
      }
    });
  }

  onNotificationCheckedChanged() {
    let ids = this.gridService.data
    .filter((i) => i.checked)
    .map((item) => item.id);
    console.log(ids);
    this.gridService.gridManager.gridSelection=ids;
  }

  openSettingsNotificationsModal() {
    this.initSettingsNotificationList();
    this.getSettingsNotification();
    this.dialogs.settingsNotifications = true;
  }

  openDeleteNotificationsConfirmModal() {
    this.confirmDialogService.open().subscribe((result) => {
      if (result == "confirm") {
        let ids = this.gridService.data
          .filter((i) => i.checked)
          .map((item) => item.id)
          .join(",");
        this.layoutService.deleteNotifications(ids).subscribe((response) => {
          if (response.Status == 200) {
            this.resetState();
          }
        });
      }
    });
  }

  doneNotifications(){
    let ids = this.gridService.data
    .filter((i) => i.checked)
    .map((item) => item.id)
    .join(",");

    for (const item of this.gridService.data.filter((i) => i.checked)) {
     item.done=1;
    }

    this.layoutService.doneNotifications(ids).subscribe((response) => {
        if (response.Status == 200) {
     
        }
    });
  }

  readNotifications(){
    let ids = this.gridService.data
    .filter((i) => i.checked)
    .map((item) => item.id)
    .join(",");

    for (const item of this.gridService.data.filter((i) => i.checked)) {
        item.isRead=1;
    }

    this.layoutService.readNotifications(ids).subscribe((response) => {
        if (response.Status == 200) {
          
        }
    });
  }

  deleteNotifications(){
    let ids = this.gridService.data
    .filter((i) => i.checked)
    .map((item) => item.id)
    .join(",");

    for (const item of this.gridService.data.filter((i) => i.checked)) {
        item.delete=1;
    }

    this.layoutService.deleteNotifications(ids).subscribe((response) => {
        if (response.Status == 200) {
          this.resetState();
        }
    });
  }

  archiveNotifications(){
    let ids = this.gridService.data
    .filter((i) => i.checked)
    .map((item) => item.id)
    .join(",");

    for (const item of this.gridService.data.filter((i) => i.checked)) {
        item.archive=1;
    }


    this.layoutService.archiveNotifications(ids).subscribe((response) => {
        if (response.Status == 200) {
          this.resetState();
        }
    });
  }

  unArchiveNotifications(){
    let ids = this.gridService.data
    .filter((i) => i.checked)
    .map((item) => item.id)
    .join(",");

    for (const item of this.gridService.data.filter((i) => i.checked)) {
        item.archive=0;
    }


    this.layoutService.archiveNotifications(ids,1).subscribe((response) => {
        if (response.Status == 200) {
          this.resetState();
        }
    });
  }

  getEmployee() {
    this.layoutService.getEmployee(this.userAuth.id).subscribe((response) => {
      if (response.Status == 200) {
        this.sendEmailNotification = response.Employee.sendEmailNotification;
      }
    });
  }

  getAllEmployees() {
    this.layoutService.getAllEmployees().subscribe((response) => {
      if (response.Status == 200) {
        this.employees = response.Employees;
      }
    });
  }

  onUserEmailNotificationChanged() {
    this.layoutService
      .sendUserEmailNotification({
        sendEmailNotification: this.sendEmailNotification ? 1 : 0,
      })
      .subscribe((response) => {
        if (response.Status == 200) {
        }

        this.dialogs.confirmDelete = false;
      });
  }

  openDeleteNotificationConfirmDialog(notification: Notification) {
    this.selectedNotification = notification;
    this.dialogs.confirmDelete = true;
  }

  openDoneNotificationConfirmDialog(notification: Notification) {
    this.selectedNotification = notification;
    this.dialogs.done = true;
  }

  openForwardNotificationDialog(notification: Notification) {
    this.getAllEmployees();
    this.selectedNotification = notification;
    this.dialogs.forward = true;
  }

 
  resetState() {
    this.gridService.stateChange$.next({ skip: 0, take: 100 });
  }

  forwardNotification() {
    this.layoutService
      .forwardNotification({
        id: this.selectedNotification.id,
        toUser: this.forwardDialogModel.emp?.id,
      })
      .subscribe((response) => {
        if (response.Status == 200) {
          this.resetState();
          this.dialogs.forward = false;
        }
      });
  }


  unReadNotification(notification: Notification){
    this.layoutService.readNotifications(notification.id,1).subscribe((response) => {
        if (response.Status == 200) {
            notification.isRead=0;
        }
    });
  }
  
  readNotification(notification: Notification){
    this.layoutService.readNotifications(notification.id).subscribe((response) => {
        if (response.Status == 200) {
            notification.isRead=1;
        }
    });
  }

  deleteNotification(notification: Notification) {

    this.layoutService
      .deleteNotification(notification.id)
      .subscribe((response) => {
        if (response.Status == 200) {
          this.resetState();
        }

      });
  }


  doneNotification(notification: Notification){
    this.layoutService.doneNotifications(notification.id,notification.done == 1 ? 1:0).subscribe((response) => {
        if (response.Status == 200) {
            notification.done=notification.done == 1 ? 0:1;
        }
    });
  }

  archiveNotification(notification: Notification){
    this.layoutService.archiveNotifications(notification.id, notification.archive == 1 ? 1:0).subscribe((response) => {
        if (response.Status == 200) {
            this.resetState();
        }
    });
  }

  showArchives(){
     this.showArchive = !this.showArchive;
     this.resetState();
  }

  onDbClickNotification(notification: Notification) {
    console.log(notification);
    this.layoutService.readNotifications(notification.id).subscribe((response) => {
        if (response.Status == 200) {
            notification.isRead=1;
        }
    });

    if(notification.type == 'shareGridSettings'){
  
      this.confirmDialogService.open({text:'Möchten Sie es annehmen?',title:'Vorlage'}).subscribe((result) => {
        if (result == 'confirm') {
          this.layoutService.acceptShareGridSettings({template:notification.extra}).subscribe((response) => {
            if (response.Status == 200) {
              this.layoutService.doneNotifications(notification.id).subscribe((response) => {
                if (response.Status == 200) {
                    notification.done=1;
                }
            });
            }
          });
        }
      });
    }
    else{
      window.open(notification.refUrl);
    }
  }
}

interface Notification {
  id?: string;
  message?: string;
  module?: string;
  projectId?: number;
  refUrl?: string;
  userOd?: number;
  isRead?:number;
  done?:number;
  archive?:number;
  type?:string;
  extra?:any;
}
